import axios from 'axios'
import { Loading } from 'quasar'
import { JtSpinner as spinner } from 'jtech-webcomps'
import { Vue } from 'vue-property-decorator'
import { GlobalController } from 'src/shared/global/GlobalController'
import { LoginController } from 'src/modules/login/LoginController'
import JtechWasteException from '../shared/exceptions/JtechWasteException'
import { JtechMessage } from 'src/plugins/system.messages'
Vue.use(JtechMessage)
export const JtechHttp = {
  instance: function () {
    return Vue.prototype.$http
  }
}
export default {

  /**
   * HTTP Request and Response manager
   *
   * @param {Object} Vue The global Vue.
   * @param {Object} options Any options we want to have in our plugin.
   * @return {void}
   */
  install (Vue, options) {
    Vue.prototype.$http = axios.create({
      baseURL: process.env.VUE_APP_URL,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      timeout: 300 * 1000,
      responseEncoding: 'iso-8859-1',
      transformRequest: [
        (data, headers) => {
          const globalController = GlobalController.getInstance()
          if (globalController && globalController.authResp && globalController.authResp.token) { headers.Authorization = 'Bearer ' + globalController.authResp.token }
          return JSON.stringify(data)
        }
      ]
    })
    this.router = options.router
    this._setupResponseInterceptor(JtechHttp.instance())
    this._setupRequestInterceptor(JtechHttp.instance())
  },

  _setupResponseInterceptor (axiosInstance) {
    const _self = this
    axiosInstance.interceptors.response.use(
      function (response) {
        _self._showMessage(response.data.messages)
        Loading.hide()
        _self._refreshToken(response)
        return response
      },
      function (error) {
        Loading.hide()
        JtechWasteException.throwWasteException(error)
        return Promise.reject(error)
      }
    )
  },

  _refreshToken (response) {
    if (response.config.url.includes('authentication')) {
      return
    }
    const globalController = GlobalController.getInstance()
    if (globalController.isRefreshToken()) {
      globalController.removeExp()
      const loginController = LoginController.getInstance()
      loginController.refreshToken()
    }
  },

  _showMessage (messages) {
    if (messages && messages.length > 0) {
      messages.forEach(message => {
        if (message.tipo === 'error') {
          JtechMessage.error(Vue.prototype.$gettext(message.msg))
        } else if (message.tipo === 'success') {
          JtechMessage.success(Vue.prototype.$gettext(message.msg))
        } else if (message.tipo === 'warning') {
          JtechMessage.warn(Vue.prototype.$gettext(message.msg))
        }
      })
    }
  },
  _setupRequestInterceptor (axiosInstance) {
    axiosInstance.interceptors.request.use(
      (config) => {
        Loading.show({
          spinner,
          spinnerSize: 140
        })
        return config
      },
      (error) => {
        Loading.hide()
        return Promise.reject(error)
      }
    )
  }
}
